import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationItem } from '../../_objects/tenant-config';
import { HttpService } from '../http.service';
import { TenantConfigContractService } from '../interfaces/tenant-config-contract.service';
import { TenantDetail } from '../../_objects/offline-management';

@Injectable({
  providedIn: 'root'
})
export class TenantConfigOnlineService extends HttpService implements TenantConfigContractService {

  readonly apiGroup = 'configuration';

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  getTenantDetails(): Observable<TenantDetail> {
    const endpoint = super.getEndpoint('tenantdata/details');

    return this.http.get<TenantDetail>(endpoint, {
      withCredentials: super.getWithCredentialsOption()
    });
  }

  /** 【TC01】テナント設定の取得
   * GET /api/configuration
   * @returns Observable
   */
  getTenantConfigs(): Observable<ConfigurationItem[]> {
    const endpoint = super.getEndpoint(this.apiGroup);

    return this.http.get<ConfigurationItem[]>(endpoint,
      { withCredentials: super.getWithCredentialsOption() });
  }

  /** 【TC02】テナント設定の更新
   * PUT /api/configuration
   * @param  {ConfigurationItem[]} configs
   * @returns Observable
   */
  putTenantConfigs(configs: ConfigurationItem[]): Observable<ConfigurationItem[]> {
    const endpoint = super.getEndpoint(this.apiGroup);

    return this.http.put<ConfigurationItem[]>(endpoint, configs,
      { withCredentials: super.getWithCredentialsOption() });
  }
}
